import {LinearProgress} from "@mui/material";
import {useCallback} from "react";
import {useNavigate, useParams} from "react-router";
import SuspenseBoundary from "../../components/SuspenseBoundary";
import Dialog from "../../components/dialog";
import AuftragSzenarioForm from "./AuftragSzenarioForm";
import {useAuftrag} from "./data";
import {AuftragMitBerechtigungen, TestSzenarioVersion} from "../../api";
import {useTestSzenario, useTestSzenarioVersion} from "../test-szenarios/data";

export default function AuftragSzenarioDialog() {
    const { auftragId } = useParams<{ auftragId: string }>();
    const navigate = useNavigate();
    const onClose = useCallback(() => {
        navigate("..");
    }, [navigate]);

    return auftragId ? (<SuspenseBoundary
        fallback={
            <Dialog title={<>Lade Auftrag&hellip;</>} open onClose={onClose}>
                <LinearProgress/>
            </Dialog>
        }
    >
        <AuftragContent auftragId={auftragId} onClose={onClose}/>
    </SuspenseBoundary>) : null;

}

function AuftragContent({
                           auftragId,
                           onClose,
                       }: {
    auftragId: string;
    onClose: () => void;
}) {
    const tempAuftrag: AuftragMitBerechtigungen = useAuftrag(auftragId);
    const testSzenarioVersion: TestSzenarioVersion = useTestSzenarioVersion(tempAuftrag.testSzenarioVersionId ?? "");
    const testSzenario = useTestSzenario(testSzenarioVersion?.testSzenarioId);

    const auftrag = {
        id: auftragId,
        crmId: tempAuftrag.crmId,
        testSzenarioVersionId: tempAuftrag.testSzenarioVersionId,
        kundeId: tempAuftrag.kundeId,
        servoTypId: tempAuftrag.servoTypId,
        auftragsnummer: tempAuftrag.auftragsnummer,
        servoMenge: tempAuftrag.servoMenge,
        testFortschritt: tempAuftrag.testFortschritt,
        geplantesStartdatum: tempAuftrag.geplantesStartdatum,
        status: tempAuftrag.status,
        berechtigungen: tempAuftrag.berechtigungen,
        erstellt: tempAuftrag.erstellt,
        bearbeitet: tempAuftrag.bearbeitet,
    }

    return (
        <Dialog title={`Auftrag ${auftrag.auftragsnummer} - Szenario zuweisen`} open onClose={onClose}>
            <AuftragSzenarioForm auftrag={auftrag} testSzenario={testSzenario} onClose={onClose}/>
        </Dialog>
    );
}
